// bundle ディレクトリ内の全ファイルを import
// const bundleContext = require.context('./bundle', true, /\.js$/);
// bundleContext.keys().forEach(bundleContext);

// HTMLElement ディレクトリ内の全ファイルを import
const htmlElementContext = require.context('./HTMLElement', true, /\.js$/);
htmlElementContext.keys().forEach(htmlElementContext);

{
  // 検索モーダルの表示・非表示制御
  const searchModal = document.getElementById('main-search');
  if (searchModal) {
    const searchModalOpenButtons = document.querySelectorAll('.js_searchModalOpen');
    searchModalOpenButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        searchModal.setAttribute('aria-hidden', false);
      });
    });

    const searchModalCloseButtons = document.querySelectorAll('.js_searchModalClose');
    searchModalCloseButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        searchModal.setAttribute('aria-hidden', true);
      });
    });
  }
}

{
  const disclosureClose = document.querySelectorAll('.js_disclosureClose');
  disclosureClose.forEach(btn => {
    btn.addEventListener('click', function() {
      document.querySelectorAll('ll-details-disclosure').forEach(el => {
        if (typeof el.closeDetails === 'function') {
          el.closeDetails();
        }
      });
    });
  });
}

{
  const quantity = document.getElementById('quantity');
  const quantityInput = document.getElementById('quantity-input');
  if (quantity && quantityInput) {
    quantityInput.addEventListener('input', function() {
      quantity.value = quantityInput.value;
    });
  }
}

{
  const CCFetchedContent = class extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then((response) => {
          const frag = document.createDocumentFragment();
          const fetchedContent = document.createElement('div');
          frag.appendChild(fetchedContent);
          fetchedContent.innerHTML = response;

          const replacementContent = fetchedContent.querySelector(`[data-id="${this.dataset.id}"]`);
          if (replacementContent) {
            this.innerHTML = replacementContent.innerHTML;
          }
        });
    }
  };

  window.customElements.define('cc-fetched-content', CCFetchedContent);
}

{
  document.addEventListener('theme:cartchanged', function () {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const countEl = document.getElementById('js_cartCount');
        if (countEl) {
          countEl.textContent = cart.item_count;
        }
      });
  });
}